import React, { useState } from "react";
import { motion } from "framer-motion";
import {logros} from "../data/logros.ts";


const categorias = [
  "Todos",
  ...Array.from(new Set(logros.map((l) => l.tipo))),
];

const Logros: React.FC = () => {
  const [busqueda, setBusqueda] = useState("");
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState("Todos");

  const logrosFiltrados = logros.filter((logro) => {
    const coincideTexto =
      `${logro.titulo} ${logro.descripcion} ${logro.tipo}`
        .toLowerCase()
        .includes(busqueda.toLowerCase());

    const coincideCategoria =
      categoriaSeleccionada === "Todos" ||
      logro.tipo === categoriaSeleccionada;

    return coincideTexto && coincideCategoria;
  });

  return (
    <motion.div
      className="max-w-6xl mx-auto px-6 py-12 mt-20"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <h2 className="text-4xl font-bold text-center text-blue-800 mb-6">
        Logros Institucionales
      </h2>

      <div className="flex flex-col md:flex-row gap-4 mb-8">
        <input
          type="text"
          placeholder="Buscar por texto..."
          className="flex-1 p-3 border rounded-xl shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
        />

        <select
         title="Filtrar por categoría"
         className="p-3 border rounded-xl shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
         value={categoriaSeleccionada}
         onChange={(e) => setCategoriaSeleccionada(e.target.value)}
        >
          {categorias.map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {logrosFiltrados.map((logro, index) => (
          <motion.div
            key={index}
            className="bg-white p-6 rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300"
            whileHover={{ scale: 1.03 }}
          >
            <h3 className="text-xl font-semibold text-blue-700 mb-2">
              {logro.titulo}
            </h3>
            <p className="text-gray-700 text-sm">{logro.descripcion}</p>
            <span className="text-xs text-gray-500 italic mt-2 inline-block">
              Categoría: {logro.tipo}
            </span>
          </motion.div>
        ))}
      </div>

      {logrosFiltrados.length === 0 && (
        <p className="text-center text-gray-500 mt-6">
          No se encontraron logros con los criterios seleccionados.
        </p>
      )}
    </motion.div>
  );
};

export default Logros;
